module.exports = "<router-outlet></router-outlet>\r\n   "